import React from 'react';
import ReactDOM from 'react-dom';
import charChoose from '../shared/CharChoose';

class UcChoose extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default charChoose(UcChoose, 'uc');


// WEBPACK FOOTER //
// ./src/components/sections/uc/UcChoose.js